import { Landmark } from "lucide-react";

export function Header() {
  return (
    <header className="hud-header" data-testid="app-header">
      <div className="hud-header-mark">
        <Landmark size={20} strokeWidth={1.6} />
      </div>
      <div className="hud-header-text">
        <h1 className="hud-title" data-testid="app-title">
          Resiliency Rating
        </h1>
        <p className="hud-subtitle">
          The Academic Boardroom · Institutional Resiliency Model
        </p>
      </div>
    </header>
  );
}
